<div>
  <app-nav-bar>
    <main class="container-main">
      <div class="row d-flex justify-content-between row-header-send">
        <div class="d-flex gap-8">
          <span class="screen-title">Gestão da Cotação</span>
        </div>
      </div>

      <div class="content-wrapper">
        <div class="dashboard-cards-container">
          <mat-card class="summary-card">
            <mat-card-content>
              <div class="summary-card-top">
                <div class="summary-card-description">
                  <div class="card-icon card-icon-blue">
                    <img
                      src="assets/icons/settings.svg"
                      alt="Provedor atual"
                      width="24"
                      height="24"
                    />
                  </div>
                  <span class="card-label">Provedor atual</span>
                </div>
              </div>
              <div class="card-value">
                <span *ngIf="!loadingProviders" class="value-text">
                  {{ currentProviderName || "—" }}
                </span>
                <span *ngIf="loadingProviders" class="value-text value-loading">Carregando...</span>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="summary-card">
            <mat-card-content>
              <div class="summary-card-top">
                <div class="summary-card-description">
                  <div
                    class="card-icon"
                    [ngClass]="isConnected ? 'card-icon-green' : 'card-icon-red'"
                  >
                    <img
                      [src]="
                        isConnected
                          ? 'assets/icons/sucess.svg'
                          : 'assets/icons/warning-card-icon.svg'
                      "
                      alt="Status da cotação"
                      width="24"
                      height="24"
                    />
                  </div>
                  <span class="card-label">Status da cotação</span>
                </div>
              </div>
              <div class="card-value">
                <span
                  *ngIf="!loading"
                  class="value-text"
                  [ngClass]="isConnected ? 'status-connected' : 'status-disconnected'"
                >
                  {{ quotationStatus || "—" }}
                </span>
                <span *ngIf="loading" class="value-text value-loading">Carregando...</span>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="summary-card">
            <mat-card-content>
              <div class="summary-card-top">
                <div class="summary-card-description">
                  <div class="card-icon card-icon-yellow">
                    <img
                      src="assets/icons/icon-clock-timer.svg"
                      alt="Última interação"
                      width="24"
                      height="24"
                    />
                  </div>
                  <span class="card-label">Última interação</span>
                </div>
              </div>
              <div class="card-value">
                <span *ngIf="!loading" class="value-text">
                  {{ lastInteraction ? formatDisplayDate(lastInteraction) : "Sem interações" }}
                </span>
                <span *ngIf="loading" class="value-text value-loading">Carregando...</span>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="card-filters">
          <div class="header-filter">
            <h5 class="title-filter">Cotação por sistema</h5>
          </div>
          <div class="content-filter" [class.systems-section-loading]="loadingSystemToggle">
            <p class="section-description">
              Ative ou desative a cotação em cada sistema integrado.
            </p>
            <form [formGroup]="toggleForm" class="systems-grid">
              <div
                class="system-toggle-item"
                *ngFor="let system of systemToggles"
              >
                <div class="system-info">
                  <span class="system-name">{{ system.label }}</span>
                  <span
                    class="system-status"
                    [class.system-status-active]="toggleForm.get(system.controlName)?.value"
                  >
                    {{
                      toggleForm.get(system.controlName)?.value
                        ? "Ativo"
                        : "Inativo"
                    }}
                  </span>
                </div>
                <mat-slide-toggle
                  [formControlName]="system.controlName"
                  (change)="onToggleChange(system.apiType, $event)"
                  color="primary"
                ></mat-slide-toggle>
              </div>
            </form>
          </div>
        </div>

        <div class="card-filters">
          <div class="header-filter">
            <h5 class="title-filter">Conexão</h5>
          </div>
          <div class="content-filter connection-section">
            <div class="connection-info">
              <p class="section-description">
                Force uma nova tentativa de conexão com o feed de cotação quando
                houver instabilidade ou desconexão.
              </p>
            </div>
            <div class="buttons-filter">
              <button
                class="btn btn-dark-primary-blue"
                type="button"
                (click)="forceReconnect()"
                [disabled]="loadingReconnect"
              >
                {{ loadingReconnect ? "Reconectando..." : "Forçar Reconexão" }}
                <span
                  class="spinner-border spinner-border-sm"
                  *ngIf="loadingReconnect"
                ></span>
              </button>
            </div>
          </div>
        </div>

        <div class="card-filters">
          <div class="header-filter">
            <h5 class="title-filter">Migração de provedor</h5>
          </div>
          <div class="content-filter">
            <p class="section-description">
              Selecione um provedor disponível para migrar a cotação.
            </p>
            <div class="row provider-migration-row align-items-center">
              <div class="col">
                <mat-form-field class="w-100 provider-select-field" appearance="outline">
                  <mat-label>Provedor de destino</mat-label>
                  <mat-select
                    [(ngModel)]="selectedProviderId"
                    [disabled]="loadingProviders || loadingSwitch"
                  >
                    <mat-option
                      *ngFor="let provider of availableProviders"
                      [value]="provider.id"
                    >
                      {{ provider.providerName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-auto provider-migration-action">
                <button
                  class="btn btn-dark-primary-blue"
                  type="button"
                  (click)="onSwitchProvider()"
                  [disabled]="!selectedProviderId || loadingSwitch || loadingProviders"
                >
                  {{ loadingSwitch ? "Migrando..." : "Migrar" }}
                  <span
                    class="spinner-border spinner-border-sm"
                    *ngIf="loadingSwitch"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <ng-container
          *ngIf="
            quotationStatus !== 'Conectada' &&
            !lastInteraction
          "
        >
          <div class="card-filters error-card">
            <div class="header-filter">
              <h5 class="title-filter">Erro de conexão</h5>
            </div>
          </div>
        </ng-container>
      </div>
    </main>
  </app-nav-bar>
</div>
